<template>
  <div class="loading-spinner">
    <div class="overlay" />
    <svg class="spinner" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;background:none;display:block;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <circle cx="50" cy="50" r="32" stroke-width="3" stroke="#0098ce" stroke-dasharray="50 50" fill="none" stroke-linecap="round"></circle>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'TWLoadingSpinner',
};
</script>

<style scoped>
.loading-spinner, .overlay {
  border-radius: inherit;
}

.overlay {
  @apply
    absolute
    w-full
    h-full
    bg-white
    opacity-70
    top-0
    left-0
    z-10;
}

.spinner {
  @apply
    z-10
    absolute
    top-2/4
    left-2/4;

  width: 150px;
  height: 150px;
  transform: translate(-50%, -50%);
  animation: 1.3s linear infinite spin;
}

@keyframes spin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

</style>
